// extracted by mini-css-extract-plugin
module.exports = {"flexible":"Flexible_flexible__5_vkh","slider":"Flexible_slider__2oQon"};